import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import strings from '../../utils/strings';
import './styles.scss';
import Logo from 'assets/logo-dysmate.png';

import {initAuthAction} from 'actions/index';
import {FEIDE} from 'constants/index';

const parsedSearch = queryString.parse(window.location.search);
const testKey = parsedSearch.key;
const authSuccess = parsedSearch.authSuccess;

function IsValidJSONString(str) {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
}

function getRawQueryParam(paramName) {
	const query = window.location.search.replace(/^\?/, '');
	const param = query
		.split('&')
		.find((part) => part.split('=')[0] === paramName);

	if (!param) {
		return null;
	}

	const equalsIndex = param.indexOf('=');
	return equalsIndex === -1 ? '' : param.substring(equalsIndex + 1);
}

function getAuthSuccessData() {
	const authSuccessPayload = getRawQueryParam('authSuccess') || authSuccess;

	if (!authSuccessPayload) {
		return null;
	}

	try {
		const decodedData = atob(decodeURIComponent(authSuccessPayload));

		if (!IsValidJSONString(decodedData)) {
			return null;
		}

		return JSON.parse(decodedData);
	} catch (e) {
		return null;
	}
}

class Signon extends React.Component {
	constructor() {
		super();

		this.state = {
			isLoginVisible: true,
			showCoockieDetectionFrame: false,
		};
	}

	componentDidMount() {
		if (!testKey && !authSuccess) {
			window.location.href = `/?error=true`;
			return;
		}

		if (authSuccess) {
			const data = getAuthSuccessData();

			if (!data) {
				return;
			}

			if (data.authError) {
				return;
			}

			if (data.action === 'auth' && data.result === 'OK') {
				localStorage.setItem('authtoken-screening', data.authToken);
				window.location.href = `/test`;
			}

			return;
		}

		var receiveMessage = function (evt) {
			if (evt.data === 'MM:3PCunsupported') {
				document.getElementById('lit-site-warning').innerHTML =
					strings.warning2;
				document.getElementById('lit-site-warning_text').innerHTML =
					strings.warning2text;
				document.getElementById(
					'lit-site-settings-instructions'
				).innerHTML = strings.linkForInstructions;
				document.getElementById('lit-site-warning_text_end').innerHTML =
					strings.warning_text_end;
			} else if (evt.data === 'MM:3PCsupported') {
				document.getElementById('result').innerHTML = '';
			}
		};
		window.addEventListener('message', receiveMessage, false);
	}

	render() {
		const {isLoginVisible} = this.state;

		if (!isLoginVisible) {
			return null;
		}

		const {error, iframeUrl, initAuth, isInit} = this.props;

		const showIframe = isInit && iframeUrl;
		const showError = isInit && error;
		const showLoginButtons = !isInit;

		if (showIframe) {
			window.location.href = `${iframeUrl}`;
		}

		return (
			<div className="Login">
				<header className="lit-header">
					<h1 className="lit-logo">
						<img
							className="lit-logo__img"
							src={Logo}
							alt="literate logo"
						/>
					</h1>
				</header>

				<div className="lit-wrapper--article text-center">
					<h2>Innlogging</h2>
					<p>
						<span>Trykk om du ønsker å logge inn med Feide.</span>
					</p>

					{showLoginButtons && (
						<div className="bank-id-type-selector-wrapper">
							<button
								className="lit-btn lit-btn--small bg-secondary"
								onClick={() => {
									this.setState({
										showCoockieDetectionFrame: true,
									});
										initAuth(FEIDE, testKey, true);
								}}
							>
								Feide
							</button>
						</div>
					)}

					<p className="lit-thirdPCsupport" id="result"></p>
					<div className="lit-thrid-party-settings">
						<p
							className="candidate-start-fail__instructions"
							style={{
								color: 'white',
								margin: 'auto',
								textAlign: 'center',
								fontSize: '18px',
							}}
						>
							<span style={{color: 'LightSalmon'}}>
								<b>
									<span id="lit-site-warning"></span>{' '}
								</b>
							</span>
							<em>
								<span id="lit-site-warning_text"></span>
							</em>
							<a
								target="_blank"
								rel="noopener noreferrer"
								href="https://www.dysmate.no/advarsel-2/"
							>
								<u style={{color: 'Yellow'}}>
									<span id="lit-site-settings-instructions"></span>
								</u>
							</a>
							<em>
								<span id="lit-site-warning_text_end"></span>
							</em>
						</p>
					</div>

					{showError && <div>{error}</div>}
					{this.state.showCoockieDetectionFrame && (
						<div>
							<iframe
								title="cookie-detection-frame"
								src="https://mindmup.github.io/3rdpartycookiecheck/start.html"
								style={{display: 'none'}}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {error, iframeUrl, isInit} = state.auth;

	return {
		error,
		iframeUrl,
		isInit,
	};
};

const mapDispatchToProps = {
	initAuth: initAuthAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Signon);
